<template>
  <div>
    <div class="double-eleven" v-if="isPC">
      <img class="banner" src="./images/pc_banner.png" alt="" />
      <img class="rules" src="./images/rules.png" alt="" />
    </div>
    <div class="min-double-eleven" v-else>
      <img class="app-bg" src="./images/app.png" alt="" />
      <img
        class="button"
        src="./images/button.png"
        alt=""
        @click="openSaving"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    openSaving() {
      this.$router.push('/saving');
    },
    setFooterStyle(display) {
      if (!this.isPC) {
        const dom = document.getElementsByTagName('footer');
        const list = [...dom];
        list.forEach(item => {
          item.style.display = display;
        });
      }
    }
  },
  mounted() {
    this.setFooterStyle('none');
  },
  destroyed() {
    this.setFooterStyle('block');
  }
};
</script>
<style lang="scss" scoped>
.double-eleven {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fffbd2;
  .banner {
    width: 100%;
  }
  .rules {
    width: 936px;
    border: 24px solid #ffffff;
  }
}
// .app-bg{
//   width: 100%;
// }
// .button{
//   width: 100%;
//   position: fixed;
//   bottom: 0;
// }
.min-double-eleven {
  width: 100%;
  display: flex;
  justify-content: center;
  .app-bg {
    width: 100%;
    // height: 1252px;
    background: url('./images/app.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .button {
    width: 100%;
    // max-width: 375px;
    position: fixed;
    bottom: 0;
  }
}
</style>
